/* eslint-disable jsx-a11y/anchor-is-valid */
// https://material-ui.com/components/links/#accessibility
import React from 'react';
import { useHistory } from 'react-router-dom';
import Link from '@material-ui/core/Link';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';

import Copyright from 'components/Copyright';

import useStyles from './Error.style';

const Error: React.FC = () => {
  const classes = useStyles();
  const history = useHistory();

  return (
    <Container component="main" maxWidth="xs" className={classes.container}>
      <div className={classes.paper}>
        <Typography variant="h1">404</Typography>
        <Link component="button" variant="h5" onClick={() => history.goBack()}>
          Go Back
        </Link>
      </div>
      <Box mt={5} className={classes.copyrightFooter}>
        <Copyright />
      </Box>
    </Container>
  );
};

export default Error;
